import $ from "jquery";

const home_hero_animation = () => {
    const init = () => {
        execute()
    }

    const execute = () => {
        const el = {
            main: '.js-home-hero',
            prev: '.js-home-hero__prev',
            next: '.js-home-hero__next',
            timeline: '.js-home-hero__time-duration'
        }
        if ($(el.main).length === 0) return;

        const $main = $(el.main);
        const $mainImage = $(el.main).find('.js-home-hero__img img');
        $mainImage?.removeAttr('srcset');
        const $timeline = $(el.timeline);
        const bgList = ($main.attr('data-bg') || '').split(',').map(s => s.trim()).filter(Boolean);
        let current = 0;
        let timer = null;
        let timelineAnim = null;
        const duration = $main.data('duration') ?? 5000; // ms

        const animateTimeline = () => {
            if (!$timeline.length) return;
            let start = null;
            $timeline[0].style.setProperty('--width', '0%');
            if (timelineAnim) cancelAnimationFrame(timelineAnim);

            const step = (timestamp) => {
                if (!start) start = timestamp;
                const progress = Math.min((timestamp - start) / duration, 1);
                $timeline[0].style.setProperty('--width', `${progress * 100}%`);
                if (progress < 1) {
                    timelineAnim = requestAnimationFrame(step);
                }
            };
            timelineAnim = requestAnimationFrame(step);
        };

        const setBg = (idx) => {
            if (!bgList.length) return;
            current = (idx + bgList.length) % bgList.length;
            $main?.[0].style.setProperty('--bg', `url(${bgList[current]})`);

            $mainImage?.[0].style.setProperty('--duration', `${duration}ms`);
            $mainImage?.removeClass('Active').addClass('Fading');
            setTimeout(() => {
                $mainImage?.attr('src', bgList[current]);
                $mainImage?.removeClass('Fading').addClass('Active');
            }, 50);
            animateTimeline();
        };

        const nextBg = () => {
            setBg(current + 1);
            resetTimer();
        };

        const prevBg = () => {
            setBg(current - 1);
            resetTimer();
        };

        const resetTimer = () => {
            if (timer) clearInterval(timer);
            timer = setInterval(() => {
                setBg(current + 1);
            }, duration);
        };

        // Initial setup
        setBg(0);
        resetTimer();

        // Button events
        $(el.next).on('click', nextBg);
        $(el.prev).on('click', prevBg);
    }
    init()
}

try {
    home_hero_animation()
} catch (error) {
    console.error('home_hero_animation', error)
}